import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV_ITEMS = [
  {
    path: '/student', label: 'Dashboard', end: true,
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>
  },
  {
    path: '/student/courses', label: 'My Courses',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" /></svg>
  },
  {
    path: '/student/calendar', label: 'Calendar',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" /></svg>
  },
  {
    path: '/student/materials', label: 'Materials',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" /></svg>
  },
  {
    path: '/student/classroom', label: 'Classroom',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342" /></svg>
  },
  {
    path: '/student/scan', label: 'Scan QR',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" /><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75H16.5v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75H16.5v-.75Z" /></svg>
  },
  {
    path: '/student/payments', label: 'Payments',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" /></svg>
  },
  {
    path: '/student/profile', label: 'Profile',
    icon: <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" /></svg>
  },
];

const StudentDashboardLayout = () => {
  const { user, studio, logout, profiles, selectedProfile, setSelectedProfile } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);

  // Greet by profile name (never the email). Fall back: selectedProfile.name →
  // user.name → 'there'. If the name happens to be an email (legacy auto-create),
  // derive a human-ish word from the local-part.
  const rawName = selectedProfile?.name || user?.name || '';
  const nameIsEmail = rawName.includes('@');
  const displayName = nameIsEmail
    ? (rawName.split('@')[0].replace(/[._+]/g, ' ') || 'there')
    : (rawName || 'there');
  const firstName = displayName.split(' ')[0];
  const hasDependents = profiles.length > 1;

  const navLinkClass = ({ isActive }) =>
    `flex items-center gap-3 px-6 py-2.5 text-sm font-medium transition-colors ${
      isActive
        ? 'text-brand-500 bg-brand-50 border-r-2 border-brand-500'
        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
    }`;

  return (
    <div className="min-h-screen bg-gray-50 flex overflow-x-hidden">
      {/* Mobile header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-white border-b border-gray-200 px-4 py-4 flex items-center gap-3">
        <button onClick={() => setMobileOpen(true)} className="text-gray-600 flex-shrink-0" aria-label="Open menu">
          <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
        </button>
        <h2 className="font-bold text-gray-900 truncate flex-1 text-center text-base sm:text-lg">{studio?.name || 'My Studio'}</h2>
        {hasDependents ? (
          <button
            onClick={() => setMobileOpen(true)}
            className="text-sm font-medium text-brand-600 bg-brand-50 px-3 py-1.5 rounded-full flex-shrink-0 max-w-[140px] truncate"
            title="Switch profile"
          >
            {displayName.split(' ')[0]}
          </button>
        ) : (
          <button onClick={() => navigate('/student/profile')} className="text-gray-500 hover:text-brand-500 flex-shrink-0 p-1" aria-label="Profile">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
            </svg>
          </button>
        )}
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-40 flex">
          <div className="fixed inset-0 bg-black/30" onClick={() => setMobileOpen(false)} />
          <aside className="relative w-64 bg-white flex flex-col z-50 shadow-xl">
            <div className="p-6 border-b border-gray-100 flex items-center justify-between">
              <div>
                <h2 className="font-bold text-lg text-gray-900 truncate">{studio?.name || 'My Studio'}</h2>
                <p className="text-sm text-gray-500 truncate">Welcome back, {firstName}</p>
              </div>
              <button onClick={() => setMobileOpen(false)} className="text-gray-400 hover:text-gray-600">
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            {hasDependents && (
              <div className="border-b border-gray-100 py-3">
                <div className="px-6 pb-1 text-xs uppercase tracking-wide text-gray-400">Profile</div>
                {profiles.map(p => (
                  <button
                    key={p._id}
                    onClick={() => { setSelectedProfile(p._id); setMobileOpen(false); }}
                    className={`w-full text-left px-6 py-2 text-sm flex items-center justify-between ${
                      selectedProfile?._id === p._id ? 'text-brand-600 font-semibold bg-brand-50' : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <span className="truncate">{p.name}{p.isSelf && <span className="text-gray-400 font-normal"> (you)</span>}</span>
                    {selectedProfile?._id === p._id && (
                      <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    )}
                  </button>
                ))}
              </div>
            )}
            <nav className="flex-1 py-4 overflow-y-auto">
              {NAV_ITEMS.map(item => (
                <NavLink key={item.path} to={item.path} end={item.end} onClick={() => setMobileOpen(false)} className={navLinkClass}>
                  {item.icon}
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <div className="p-4 border-t border-gray-100">
              <button onClick={logout} className="w-full text-left px-4 py-2 text-sm text-gray-500 hover:text-gray-700">Log out</button>
            </div>
          </aside>
        </div>
      )}

      {/* Desktop sidebar */}
      <aside className="hidden lg:flex w-64 bg-white border-r border-gray-200 flex-col fixed h-screen z-20">
        <div className="p-5 border-b border-gray-100 flex items-center gap-3">
          {studio?.branding?.logo ? (
            <img src={studio.branding.logo} alt="" className="w-9 h-9 rounded-lg object-contain flex-shrink-0" />
          ) : null}
          <h2 className="font-bold text-lg text-gray-900 truncate">{studio?.name || 'My Studio'}</h2>
        </div>

        <nav className="flex-1 py-4 overflow-y-auto">
          {NAV_ITEMS.map(item => (
            <NavLink key={item.path} to={item.path} end={item.end} className={navLinkClass}>
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-100">
          <button onClick={logout} className="w-full text-left px-4 py-2 text-sm text-gray-500 hover:text-gray-700 transition-colors">Log out</button>
        </div>
      </aside>

      {/* Main content area */}
      <div className="flex-1 lg:ml-64 flex flex-col overflow-x-hidden">
        {/* Desktop top header */}
        <header className="hidden lg:flex items-center justify-between bg-white border-b border-gray-200 px-8 py-3 sticky top-0 z-10">
          <p className="text-sm text-gray-500">
            Welcome back, <span className="font-medium text-gray-700">{firstName}</span>
            {hasDependents && selectedProfile && !selectedProfile.isSelf && (
              <span className="ml-2 text-xs text-brand-600 bg-brand-50 px-2 py-0.5 rounded">Viewing as {selectedProfile.name}</span>
            )}
          </p>
          <div className="flex items-center gap-3 relative">
            {hasDependents && (
              <div className="relative">
                <button
                  onClick={() => setPickerOpen(o => !o)}
                  className="flex items-center gap-2 text-sm px-3 py-1.5 rounded-full border border-gray-200 hover:border-brand-300 hover:bg-brand-50 transition-colors"
                >
                  <span className="font-medium text-gray-700 max-w-[120px] truncate">{selectedProfile?.name || 'Profile'}</span>
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                {pickerOpen && (
                  <>
                    <div className="fixed inset-0 z-10" onClick={() => setPickerOpen(false)} />
                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-20">
                      <div className="px-3 py-1.5 text-xs uppercase tracking-wide text-gray-400">Switch profile</div>
                      {profiles.map(p => (
                        <button
                          key={p._id}
                          onClick={() => { setSelectedProfile(p._id); setPickerOpen(false); }}
                          className={`w-full text-left px-3 py-2 text-sm flex items-center justify-between hover:bg-gray-50 ${
                            selectedProfile?._id === p._id ? 'text-brand-600 font-medium' : 'text-gray-700'
                          }`}
                        >
                          <span className="truncate">{p.name}{p.isSelf && <span className="text-gray-400 font-normal"> (you)</span>}</span>
                          {selectedProfile?._id === p._id && (
                            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                          )}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
            <button
              onClick={() => navigate('/student/profile')}
              className="w-8 h-8 rounded-full bg-brand-100 flex items-center justify-center text-sm font-semibold text-brand-600 hover:bg-brand-200 transition-colors"
              title="Profile"
            >
              {(user?.name || '?')[0].toUpperCase()}
            </button>
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-6xl mx-auto px-4 py-4 pt-20 sm:px-6 lg:px-8 lg:py-8 lg:pt-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default StudentDashboardLayout;
